import { Vue } from "vue-property-decorator"

export default class VehicleTypeModel extends Vue {
    constructor(car: string, van: string, dualPurposeCar: string, camperVan: string, truck: string) {
        super()

        this.car = car
        this.van = van
        this.dualPurposeCar = dualPurposeCar
        this.camperVan = camperVan
        this.truck = truck
    }

    car: string
    van: string
    dualPurposeCar: string
    camperVan: string
    truck: string

    ToStringArray() {
        return [this.car, this.van, this.dualPurposeCar, this.camperVan, this.truck]
    }
}
